/**
 * AGM 폼 Edit 복원 — watcher 가 중간 값을 덮어쓰지 않도록 필드 적용 순서 보장.
 * (directorCount 복원 시 specifySigners/signers 가 아직 false/[] 이면 auto-sync 가 저장값을 지움)
 */
export const AGM_DEFERRED_RESTORE_ORDER = [
  'memberType',
  'memberName',
  'memberRepresentativeName',
  'members',
  'hasRetiringDirectors',
  'retiringDirectors',
  'specifySigners',
  'signers',
  'directorCount',
] as const;

function cloneFieldValue(val: unknown): unknown {
  if (val && typeof val === 'object') {
    return JSON.parse(JSON.stringify(val));
  }
  return val;
}

export function restoreReactiveFormFields<T extends Record<string, unknown>>(
  target: T,
  src: Record<string, unknown>,
  deferredKeys: readonly string[] = AGM_DEFERRED_RESTORE_ORDER,
): void {
  const deferredSet = new Set(deferredKeys);
  const deferred: Record<string, unknown> = {};

  for (const key of Object.keys(target)) {
    if (src[key] === undefined) continue;
    if (deferredSet.has(key)) {
      deferred[key] = src[key];
      continue;
    }
    (target as Record<string, unknown>)[key] = cloneFieldValue(src[key]);
  }

  for (const key of deferredKeys) {
    if (deferred[key] === undefined) continue;
    (target as Record<string, unknown>)[key] = cloneFieldValue(deferred[key]);
  }
}
